import React from 'react';
import PropTypes from 'prop-types';

const PinCodeIcon = ({ className = null }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    className={className}
  >
    <path d="M93.85-501.54v-49.23h49.23v49.23H93.85Zm723.07 0v-49.23h49.23v49.23h-49.23ZM93.85-646.15v-49.23h49.23v49.23H93.85Zm723.07 0v-49.23h49.23v49.23h-49.23ZM93.85-790.77V-840h49.23v49.23H93.85Zm144.61 289.23v-49.23h49.23v49.23h-49.23Zm433.85 0v-49.23h49.23v49.23h-49.23Zm144.61-289.23V-840h49.23v49.23h-49.23Zm-578.46 0V-840h49.23v49.23h-49.23Zm144.62 0V-840h49.23v49.23h-49.23Zm144.61 0V-840h49.23v49.23h-49.23Zm144.62 0V-840h49.23v49.23h-49.23Zm-205.58 690q-20.04 0-37.81-7.46-17.77-7.46-32.28-21.87L222.46-303.85l23-24q9.39-9.38 21.69-11.69 12.31-2.31 25.39 1.16l81.31 18.46V-640q0-8.5 5.75-14.25 5.76-5.75 14.27-5.75t14.25 5.75q5.73 5.75 5.73 14.25v373l-129.54-32.61 139.92 141.46q9.08 9.07 19.54 13.23 10.46 4.15 23.08 4.15h139.3q41.25 0 70.63-29.37 29.37-29.38 29.37-70.63v-126.92q0-8.5 5.76-14.25t14.27-5.75q8.51 0 14.24 5.75t5.73 14.25v126.92q0 58.31-40.84 99.15-40.85 40.85-99.16 40.85H466.73Zm17.89-256.92v-160.77q0-8.5 5.75-14.25 5.76-5.75 14.27-5.75t14.24 5.75q5.74 5.75 5.74 14.25v160.77h-40Zm110.76 0v-105.39q0-8.5 5.76-14.25t14.27-5.75q8.51 0 14.24 5.75t5.73 14.25v105.39h-40Zm10.77 216.92H424.23 606.15Z" />
  </svg>
);

PinCodeIcon.propTypes = {
  className: PropTypes.string,
};


export default PinCodeIcon;
